type Specifications = {
  quantitySettings?: { type?: string; values?: unknown[] };
  priceMatrix?: { enabled?: boolean };
  livePrintComPricing?: unknown;
};

/** Local fixed matrices are exhaustive, unlike supplier convenience presets.
 * Keep mixed live Print.com execution products on their existing policy path. */
export function getClosedCustomQuantities(provider: string | undefined, specs?: Specifications | null): number[] | null {
  if (provider !== 'CUSTOM' || specs?.livePrintComPricing || specs?.priceMatrix?.enabled !== true || specs?.quantitySettings?.type !== 'fixed') return null;
  return [...new Set((Array.isArray(specs.quantitySettings.values) ? specs.quantitySettings.values : []).map(Number)
    .filter(value => Number.isSafeInteger(value) && value > 0))].sort((a, b) => a - b);
}

export function isAllowedClosedQuantity(value: number, allowed: readonly number[] | null): boolean {
  return allowed === null || allowed.includes(value);
}

/** Missing exact matrix entries must not inherit the selected row's price. */
export function customMatrixRowTotal(price: unknown, quantity: number, orderTotal: boolean, discount = 0, orderModifier = 0): number | null {
  const value = Number(price);
  if (!Number.isFinite(value) || value <= 0) return null;
  return value * (1 - discount) * (orderTotal ? 1 : quantity) + orderModifier;
}
